import React, { ReactNode, useCallback, useState } from 'react';
import { ToastContext } from './Toast.context';
import { ToastProps } from '../Toast.types';
import { Toast } from '../Toast';

export function ToastProvider({ children }: { children?: ReactNode }) {
  const [toastProps, toggleToast] = useState<ToastProps | null>(null);
  const onClose = useCallback(() => {
    toggleToast(null);
  }, [toggleToast]);

  return (
    <ToastContext.Provider value={{ toastProps, toggleToast }}>
      {children}
      {toastProps ? <Toast {...toastProps} onClose={onClose} /> : null}
    </ToastContext.Provider>
  );
}
